export const DISPLAY_EVENTS = {
  clearPlayerDarts: "CLEAR_PLAYER_DARTS",
  dartThrow: "DART_THROW",
  gameFinished: "GAME_FINISHED",
  gameStarted: "GAME_STARTED",
  resetScene: "RESET_SCENE",
  syncPlayerDarts: "SYNC_PLAYER_DARTS",
} as const;
